<template>
  <div class="navbar">
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'roleAuthList'
    ])
  }
}
</script>
<style lang="scss" scoped>
.navbar {
  height: 48px;
  background: #2c3b4e;
}

</style>
